import { post } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { z } from "zod";

interface PlacementCandidateBanContactSupportParams {
  banId: string;
}

export function usePlacementCandidateBanContactSupport(
  options: UseMutationOptions<unknown, unknown, PlacementCandidateBanContactSupportParams>
) {
  return useMutation({
    mutationFn: async (params: PlacementCandidateBanContactSupportParams) => {
      const { banId } = params;

      await post({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/placement-candidate-bans/${banId}/contact-support`,
        data: {},
        responseSchema: z.object({}),
        requestSchema: z.object({}),
      });
    },
    ...options,
  });
}
